import logoFamily from '../assets/family/Berg_Family_Logo_Horizontal.svg?raw';
import monogramFamily from '../assets/family/Berg_Family_Monogram.svg?raw';

// Berg Family wordmark. The SVG source lives at src/assets/family/ so it
// can be swapped without touching this component. We inline the markup
// (rather than using <img>) so CSS can recolor the letter paths to
// `currentColor` — see `.brand-logo path` in index.css.
//
// `monogram` is the square B on its own (the app icon's glyph, without the
// tile) for tight spots like the phone topbar.

type Props = {
  className?: string;
  ariaLabel?: string;
  variant?: 'wordmark' | 'monogram';
};

export function BrandMark({ className, ariaLabel = 'Berg', variant = 'wordmark' }: Props) {
  return (
    <span
      role="img"
      aria-label={ariaLabel}
      className={['brand-logo', className].filter(Boolean).join(' ')}
      dangerouslySetInnerHTML={{ __html: variant === 'monogram' ? monogramFamily : logoFamily }}
    />
  );
}
